module.exports = __webpack_public_path__ + "img/pdf.e09fec0.svg";